import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getApi } from '../../../api/api'
import { CategoryInterface } from '../../../common/types/interfaces'
import { useItem } from '../../item/useItem'
import { useScrollPagination } from '../../../common/hooks/useScrollPagination'

export const useCategoryDetails = () => {
  const { id } = useParams<{ id: string }>()

  const [category, setCategory] = useState<CategoryInterface | null>(null)
  const [categoryReady, setCategoryReady] = useState(false)

  useEffect(() => {
    if (!id) return
    let cancelled = false

    getApi()
      .getCategories()
      .then((res) => {
        if (!cancelled) {
          const found = res.data.find((c) => c.id === Number(id))
          setCategory(found || null)
          setCategoryReady(true)
        }
      })
      .catch(() => {
        if (!cancelled) {
          setCategory(null)
          setCategoryReady(true)
        }
      })

    return () => { cancelled = true }
  }, [id])

  const { 
    items, 
    total, 
    ready: itemsReady, 
    isFetching, 
    isFetchingMore, 
    hasMore, 
    loadMore 
  } = useItem(Number(id))

  const { lastItemRef } = useScrollPagination(hasMore, isFetchingMore, loadMore)

  return {
    category,
    items,
    total,
    ready: categoryReady && itemsReady,
    isFetching,
    isFetchingMore,
    lastItemRef,
  }
}
